import {ModelType} from "~/enums/modelType";

export enum DocumentType {
  document = 0,
  form = 1,
  license = 2,
  portal = 3,
  certificate = 4,
  objectModel = 5,
  listView = 6,
  detailView = 7,
  mapping = 8,
  publicProfile = 9,
  entityType = 10,
  processFlow = 11,
  visualization = 12,
  userType = 13,
  dashboard = 14,
  application = 15,
}

export let  DocumentTypeName: { [key in DocumentType]?: string } = {
  [DocumentType.form]: 'form',
  [DocumentType.license]: 'license',
  [DocumentType.portal]: 'portal',
  [DocumentType.certificate]: 'document',
  [DocumentType.objectModel]: 'object model',
  [DocumentType.listView]: 'list view',
  [DocumentType.detailView]: 'detail view',
  [DocumentType.mapping]: 'mapping',
  [DocumentType.publicProfile]: 'public profile',
  [DocumentType.entityType]: "entity type",
  [DocumentType.processFlow]: "process flow",
  [DocumentType.visualization]: "visualization",
  [DocumentType.userType]: 'user type',
  [DocumentType.dashboard]: 'dashboard',
};

export enum DocumentTypeToModelTypeMap {
  document = 0,
  form = ModelType.Form,
  license = ModelType.License,
  portal = ModelType.Portal,
  certificate = ModelType.Certificate,
  objectModel = ModelType.ObjectModel,
  listView = ModelType.ContentListView,
  detailView = ModelType.ContentDetailView,
  mapping = ModelType.Mapping,
  publicProfile = ModelType.PublicProfile,
  entityType = ModelType.EntityType,
  processFlow = ModelType.ProcessFlow,
  visualization = ModelType.Visualization,
  userType = ModelType.UserType,
  dashboard = ModelType.Dashboard,
  application = 15
}

export enum DocumentTypeClassName {
  '' = DocumentType.document,
  'Form' = DocumentType.form,
  'License' = DocumentType.license,
  'Portal' = DocumentType.portal,
  'Certificate' = DocumentType.certificate,
  'ObjectModel' = DocumentType.objectModel,
  'Content::ListView' = DocumentType.listView,
  'Content::DetailView' = DocumentType.detailView,
  'Mapping' = DocumentType.mapping,
  'PublicProfile' = DocumentType.publicProfile,
  'EntityType' = DocumentType.entityType,
  'ProcessFlow' = DocumentType.processFlow,
  'Visualization' = DocumentType.visualization,
  'UserType' = DocumentType.userType,
  'Dashboard' = DocumentType.dashboard,
  'Application' = DocumentType.application,
}
